import '../utilities/index.js';
import './rightclick.js';